import { ApiService } from '../../theme/utils/api.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NoInternetHelper } from '../../theme/utils/no-internet-helper';

@Injectable({ providedIn: 'root' })
export class LigneBudgetService {
  ligneBudget: any;
  public edit: boolean = false;
  public budgetUuid: string = '';
  private url = 'private/trustee/lignebudget';

  constructor(private api: ApiService) {}

  setLigneBudget(data: any) { this.ligneBudget = data; }
  getLigneBudget(): any { return this.ligneBudget; }

  add(data: any): Observable<any> {
    if (!navigator.onLine) { NoInternetHelper.internet(); return Observable.create(obs => { obs.next(); obs.complete(); }); }
    return data.uuid ? this.update(data) : this.create(data);
  }

  create(data: any): Observable<any> {
    return this.api._post(`${this.url}/new`, data).pipe(map((r: any) => r), catchError((e: any) => throwError(e)));
  }

  update(data: any): Observable<any> {
    return this.api._post(`${this.url}/${data?.uuid}/edit`, data).pipe(map((r: any) => r), catchError((e: any) => throwError(e)));
  }

  getList(budget?: string): Observable<any[]> {
    if (!navigator.onLine) { NoInternetHelper.internet(); return Observable.create(obs => { obs.next(); obs.complete(); }); }
    return this.api._get(`${this.url}`, { budget }).pipe(map((r: any) => r), catchError((e: any) => throwError(e)));
  }

  getSingle(uuid: string): Observable<any> {
    if (!navigator.onLine) { NoInternetHelper.internet(); return Observable.create(obs => { obs.next(); obs.complete(); }); }
    return this.api._get(`${this.url}/${uuid}/show`).pipe(map((r: any) => r.data), catchError((e: any) => throwError(e)));
  }

  getDelete(uuid: string): Observable<any> {
    if (!navigator.onLine) { NoInternetHelper.internet(); return Observable.create(obs => { obs.next(); obs.complete(); }); }
    return this.api._delete(`${this.url}/${uuid}/delete`).pipe(map((r: any) => r), catchError((e: any) => throwError(e)));
  }
}
